// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

// Atoms
import Link from 'atoms/Link';
import Svg from 'atoms/Svg';

// Icons
import blogSymbol from 'assets/icons/blog.svg';
import facebookSymbol from 'assets/icons/facebook.svg';
import instagramSymbol from 'assets/icons/instagram.svg';
import appStoreSymbol from 'assets/icons/app-store.svg';

// Styles
import styles from './styles';

const iconLinks = [
];

const textLinks = [
  { to: 'mailto:hello@tewtor.com', external: true, label: 'Contact us' },
  { to: '/terms', label: 'Terms' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: 'https://indemandly.com/', label: '© Indemandly', external: true }
];

@withStyles(styles)
export default class FooterMenu extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.iconLinks}>
          { iconLinks.map(iconLink => (
            <a key={iconLink.href} href={iconLink.href} className={classes.iconLink}>
              <Svg symbol={iconLink.icon} />
            </a>
          )) }
        </div>

        <div className={classes.textLinks}>
          { textLinks.map(textLink => (
            <Link
              key={textLink.to}
              to={textLink.to}
              external={textLink.external}
              className={classes.textLink}
            >
              { textLink.label }
            </Link>
          )) }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Menu/index.js